import React, { Component } from 'react';
import { Modal, Button, Table } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

class ChangeLog extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = (record = {}) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    loadData = () => {
        const { evaluateRecordId } = this.props;
        if (!evaluateRecordId) {
            return
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEvaluateVisitServeFeeLog,
            data: { evaluateRecordId },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: res.data,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '更新时间',
        dataIndex: 'updateTime',
        key: 'updateTime',
        width: 100,
    }, {
        title: '更新人',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        width: 100,
    }, {
        title: '更新字段',
        dataIndex: 'evaluateServeName',
        key: 'evaluateServeName',
        width: 120,
    }, {
        title: '更新前',
        dataIndex: 'oldValue',
        key: 'oldValue',
        width: 120,
        render: (text) => {
            return text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
        }
    }, {
        title: '更新后',
        dataIndex: 'newValue',
        key: 'newValue',
        width: 120,
        render: (text) => {
            return text ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
        }
    }]

    render() {
        const { visible, loading, data } = this.state;
        return (
            <Modal
                title="变更日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="1000px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div>
                        <Table
                            dataSource={data}
                            loading={loading}
                            columns={this.getColumns()}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ChangeLog;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/ChangeLog.js